/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DisableWebhooksSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type DisableWebhooksRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type DisableWebhooksSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DisableWebhooksSecurity$outboundSchema: z.ZodMiniType<
  DisableWebhooksSecurity$Outbound,
  DisableWebhooksSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function disableWebhooksSecurityToJSON(
  disableWebhooksSecurity: DisableWebhooksSecurity,
): string {
  return JSON.stringify(
    DisableWebhooksSecurity$outboundSchema.parse(disableWebhooksSecurity),
  );
}

/** @internal */
export type DisableWebhooksRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const DisableWebhooksRequest$outboundSchema: z.ZodMiniType<
  DisableWebhooksRequest$Outbound,
  DisableWebhooksRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function disableWebhooksRequestToJSON(
  disableWebhooksRequest: DisableWebhooksRequest,
): string {
  return JSON.stringify(
    DisableWebhooksRequest$outboundSchema.parse(disableWebhooksRequest),
  );
}
